import Icon from './Icon';

const PlayOutline = (props) => (
  <Icon
    width="16px"
    height="16px"
    size="16px"
    viewBox="0 0 16 16"
    strokeWidth="1.5"
    stroke="#A2A0A2"
    color="none"
    {...props}
    path="M5.54408 14.1326L5.29307 13.4259L5.54408 14.1326C8.4141 13.1133 11.1038 11.6442 13.5126 9.7804C14.6769 8.87952 14.6769 7.12176 13.5126 6.22087C11.1038 4.35705 8.4141 2.88798 5.54408 1.86866L5.03345 1.6873C3.59306 1.17573 2.0902 2.15158 1.89776 3.61895C1.51976 6.50125 1.51976 9.50003 1.89776 12.3823C2.0902 13.8497 3.59306 14.8256 5.03345 14.314L5.54408 14.1326Z"
  />
);

export default PlayOutline;
